import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils';

export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-skeleton motion-reduce:animate-none', className)}
      {...props}
      aria-hidden="true"
    />
  );
}
